import * as ActionTypes from "../ActionTypes";

const initialState = {
    isSuccess: false,
    isError: false,
    errorMessage: "",
    successMessage: "",
    goal_types: [],
    goalTypeLoading: false,
    goal_subtypes: [],
    goalSubtypeLoading: false,
};

export const GoalReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.GOAL_TYPE_GET_REQUEST:
        return {
            ...state,
            goalTypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            goal_types: []
        };
        case ActionTypes.GOAL_TYPE_ADD_REQUEST:
        case ActionTypes.GOAL_TYPE_UPDATE_REQUEST:
        case ActionTypes.GOAL_TYPE_DELETE_REQUEST:
        return {
            ...state,
            goalTypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
        };

        case ActionTypes.GOAL_TYPE_GET_SUCCESS:
        case ActionTypes.GOAL_TYPE_ADD_SUCCESS:
        case ActionTypes.GOAL_TYPE_UPDATE_SUCCESS:
        case ActionTypes.GOAL_TYPE_DELETE_SUCCESS:
        return {
            ...state,
            goalTypeLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            goal_types: action.payload?.data?.data || [],
        };

        case ActionTypes.GOAL_TYPE_GET_ERROR:
        case ActionTypes.GOAL_TYPE_ADD_ERROR:
        case ActionTypes.GOAL_TYPE_UPDATE_ERROR:
        case ActionTypes.GOAL_TYPE_DELETE_ERROR:
        return {
            ...state,
            goalTypeLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message || "Error in goal type",
        };

        // Expense Subtype
        case ActionTypes.GOAL_SUBTYPE_GET_REQUEST:
        return {
            ...state,
            goalSubtypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
            goal_subtypes: []
        };
        case ActionTypes.GOAL_SUBTYPE_ADD_REQUEST:
        case ActionTypes.GOAL_SUBTYPE_UPDATE_REQUEST:
        case ActionTypes.GOAL_SUBTYPE_DELETE_REQUEST:
        return {
            ...state,
            goalSubtypeLoading: true,
            isSuccess: false,
            isError: false,
            errorMessage: "",
        };

        case ActionTypes.GOAL_SUBTYPE_GET_SUCCESS:
        case ActionTypes.GOAL_SUBTYPE_ADD_SUCCESS:
        case ActionTypes.GOAL_SUBTYPE_UPDATE_SUCCESS:
        case ActionTypes.GOAL_SUBTYPE_DELETE_SUCCESS:
        return {
            ...state,
            goalSubtypeLoading: false,
            isSuccess: true,
            successMessage: action.payload?.message,
            goal_subtypes: action.payload?.data?.data || [],
        };

        case ActionTypes.GOAL_SUBTYPE_GET_ERROR:
        case ActionTypes.GOAL_SUBTYPE_ADD_ERROR:
        case ActionTypes.GOAL_SUBTYPE_UPDATE_ERROR:
        case ActionTypes.GOAL_SUBTYPE_DELETE_ERROR:
        return {
            ...state,
            goalSubtypeLoading: false,
            isError: true,
            errorMessage:
            action.payload?.data?.error?.[0]?.message ||
            "Error in goal subtype",
        };
        default:
        return state;
    }
};